import React, { useState } from 'react';
import '../styling/Header.css';

function Header() {

    const scrollToSection = (id) => {
        const section = document.getElementById(id);
        if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <header className="main-header">
        <nav className="desktop-nav">
            <ul>
            <li>
                <button onClick={() => scrollToSection('games')}>Games</button>
            </li>
            <li>
                <button onClick={() => scrollToSection('about')}>About</button>
            </li>
            <li className="logo-item">
                <button onClick={() => scrollToSection('hero')}>
                <img src='./Kyro-Studios.png' alt="Logo" className='logo' />
                </button>
            </li>
            <li>
                <button onClick={() => scrollToSection('contact')}>News</button>
            </li>
            <li>
                <button onClick={() => scrollToSection('updates')}>Updates</button>
            </li>
            </ul>
        </nav>

        <div className="mobile-nav">
            <div className="mobile-header">
            <div className="logo-container">
                <button onClick={() => scrollToSection('hero')}>
                <img src='./Kyro-Studios.png' alt="Logo" className='logo' />
                </button>
            </div>
            <button 
                className="menu-toggle" 
                onClick={() => setMenuOpen(!menuOpen)}
                aria-label="Toggle navigation menu"
            >
                &#9776;
            </button>
            </div>
            {menuOpen && (
            <nav className="dropdown-menu">
                <ul>
                <li>
                    <button onClick={() => { scrollToSection('games'); setMenuOpen(false); }}>Games</button>
                </li>
                <li>
                    <button onClick={() => { scrollToSection('about'); setMenuOpen(false); }}>About</button>
                </li>
                <li>
                    <button onClick={() => { scrollToSection('contact'); setMenuOpen(false); }}>News</button>
                </li>
                <li>
                    <button onClick={() => { scrollToSection('updates'); setMenuOpen(false); }}>Updates</button>
                </li>
                </ul>
            </nav>
            )}
        </div>
    </header>
  );
}

export default Header;
